import {LanguageDefinition} from './types';
import {informLanguage} from './languages/inform';
import {fanucTpLanguage} from './languages/fanuc-tp';

/**
 * 登録された言語定義一覧
 */
const languages: LanguageDefinition[] = [informLanguage, fanucTpLanguage];

/**
 * 拡張子から言語定義を取得
 * @param ext 拡張子（ドット付き、例: ".jbl"）
 */
export function getLanguageByExtension(ext: string): LanguageDefinition | null {
  const lowerExt = ext.toLowerCase();
  return languages.find(lang => lang.extensions.includes(lowerExt)) ?? null;
}

/**
 * ファイル名から言語定義を取得
 * @param fileName ファイル名（例: "program.jbl"）
 */
export function getLanguageByFileName(fileName: string | null): LanguageDefinition | null {
  if (!fileName) return null;
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex === -1) return null;
  const ext = fileName.substring(dotIndex).toLowerCase();
  return getLanguageByExtension(ext);
}

/**
 * 登録された全言語を取得
 */
export function getAllLanguages(): LanguageDefinition[] {
  return [...languages];
}
